import API from './axios';

// Driver Management API Service
export const driverService = {
  // Get all drivers with pagination and filters
  getAllDrivers: async (params = {}) => {
    const { page = 1, limit = 20, status, search } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(status && { status }),
      ...(search && { search })
    });

    const response = await API.get(`/admin/drivers?${queryParams}`);
    return response.data;
  },

  // Get driver by ID
  getDriverById: async (driverId) => {
    const response = await API.get(`/admin/drivers/${driverId}`);
    return response.data;
  },

  // Update driver
  updateDriver: async (driverId, updateData) => {
    const response = await API.put(`/admin/drivers/${driverId}`, updateData);
    return response.data;
  },

  // Deactivate driver
  deactivateDriver: async (driverId) => {
    const response = await API.delete(`/admin/drivers/${driverId}`);
    return response.data;
  },

  // Verify driver
  verifyDriver: async (driverId) => {
    const response = await API.post(`/admin/drivers/${driverId}/verify`);
    return response.data;
  },

  // Suspend driver
  suspendDriver: async (driverId) => {
    const response = await API.post(`/admin/drivers/${driverId}/suspend`);
    return response.data;
  },

  // Activate driver
  activateDriver: async (driverId) => {
    const response = await API.post(`/admin/drivers/${driverId}/activate`);
    return response.data;
  },

  // Get driver analytics
  getDriverAnalytics: async () => {
    const response = await API.get('/admin/analytics/drivers');
    return response.data;
  }
};

export default driverService; 